import React, { useState } from 'react'
import CoverAndDescription from './essentialComp/CoverAndDescription'
import RequiredDetails from './essentialComp/RequiredDetails'
import Security from './essentialComp/Security'
import { CaretLeft } from '@phosphor-icons/react'
import { Button } from 'antd'
import ButtonSpinner from 'components/global/ButtonSpinner'
import {
  EventStep6Payload,
  KidsRequiredDetails,
  ParentRequiredDetailsType,
  RequiredDeatilsTypes,
} from 'types/event/eventStep5'
import { creationEventStore } from 'state/event/eventCreationStore'
import { useEventStep6 } from 'api/EventCreation/creationStep6'
import Confirmationmodal from '../Step5/Modals/Confirmationmodal'
import { infoMessage } from 'api/global'
import DocumentToggle from './essentialComp/DocumentToggle'
import MentorRequest from './essentialComp/MentorRequest'

interface AdditionalEventSettingsProps {
  handleNext: (data: any) => void
  handleBack: () => void
}

const Settings: React.FC<AdditionalEventSettingsProps> = ({
  handleNext,
  handleBack,
}) => {
  const [confirmModal, setConfirmModal] = useState<boolean>(false)
  const {
    eventData,
    coverPhotoIds,
    description,
    riskLevel,
    requiredDetails,
    documentsApprovalRequired,
    setEventData,
  } = creationEventStore(store => ({
    eventData: store.eventData,
    coverPhotoIds: store.coverPhotoIds,
    description: store.description,
    riskLevel: store.riskLevel,
    requiredDetails: store.requiredDetails,
    documentsApprovalRequired: store.documentsApprovalRequired,
    setEventData: store.setEventData,
  }))

  const { mutate: step6Mutation, isLoading: step6MutationLoading } =
    useEventStep6()

  const mapToKeyValueObject = (arr: RequiredDeatilsTypes[]) => {
    return arr?.reduce(
      (acc, item) => {
        acc[item.key] = item.value
        return acc
      },
      {} as ParentRequiredDetailsType | KidsRequiredDetails,
    )
  }

  const handlePublish = () => {
    if (coverPhotoIds.length === 0) {
      infoMessage('Cover photo is required')
      return
    }
    const payload: EventStep6Payload = {
      coverPhotosIds: coverPhotoIds,
      description: description,
      parentRequiredDetails: mapToKeyValueObject(
        requiredDetails.guardians,
      ) as ParentRequiredDetailsType,
      authorizedAdultRequiredDetails: mapToKeyValueObject(
        requiredDetails.adults,
      ) as ParentRequiredDetailsType,
      kidRequiredDetails: mapToKeyValueObject(
        requiredDetails.kids,
      ) as KidsRequiredDetails,
      riskLevel: riskLevel,
      documentsApprovalRequired: documentsApprovalRequired,
    }

    step6Mutation(
      { payload, eventId: eventData._id },
      {
        onSuccess: data => {
          setEventData({ ...eventData, ...data })
          setConfirmModal(true)
        },
      },
    )
  }

  return (
    <>
      <div className="additional-setting-container">
        <div>
          <h3 className="text-24 w-600"> Step 6. Settings</h3>
        </div>
        <div className="mt-30px overflow-auto-y scroller overflow-hidden-x content-container">
          <div className="mt-20px">
            <CoverAndDescription />
          </div>
          <div className="mt-20px">
            <RequiredDetails />
          </div>
          <div className="mt-20px">
            <MentorRequest />
          </div>
          <div className="mt-20px">
            <Security />
          </div>
          <div className="mt-20px">
            <DocumentToggle />
          </div>
        </div>

        <div className="mt-30px event-button-cont">
          <h5
            className="flex gap-10px align-center pointer"
            onClick={() => handleBack()}
          >
            <CaretLeft size={20} color="#000" />
            <span className="text-15 w-500">Back</span>
          </h5>
          <Button
            className="stepper-button"
            disabled={step6MutationLoading}
            onClick={handlePublish}
          >
            {step6MutationLoading ? (
              <ButtonSpinner size={20} color="#000" />
            ) : (
              <span className="text-15 w-500">Publish Event</span>
            )}
          </Button>
        </div>
      </div>

      {confirmModal && (
        <Confirmationmodal
          openModal={confirmModal}
          closeModal={setConfirmModal}
        />
      )}
    </>
  )
}

export default Settings
